import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-950 no-underline group"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-open-line text-lg text-background-50"></i>
            </div>
            <span className="font-heading text-xl font-bold tracking-tight">樱花漫画</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/category/riman"
              className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
            >
              日漫
            </Link>
            <Link
              to="/category/hanman"
              className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
            >
              韩漫
            </Link>
            <Link
              to="/category/guoman"
              className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
            >
              国漫
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              onClick={() => navigate('/category/all')}
              className="flex items-center gap-2 px-4 py-2 bg-background-100 hover:bg-background-200 rounded-full text-sm text-foreground-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-search-line text-base w-4 h-4 flex items-center justify-center"></i>
              <span>搜索漫画</span>
            </button>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="切换菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4 flex flex-col gap-3">
          <Link to="/" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap">首页</Link>
          <Link to="/category/all" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap">分类浏览</Link>
          <Link to="/category/riman" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap">日漫</Link>
          <Link to="/category/hanman" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap">韩漫</Link>
          <Link to="/category/guoman" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap">国漫</Link>
          <Link to="/about" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap">关于我们</Link>
          <button
            onClick={() => { setMobileOpen(false); navigate('/category/all'); }}
            className="flex items-center gap-2 px-4 py-2.5 bg-background-100 rounded-full text-sm text-foreground-700 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-search-line w-4 h-4 flex items-center justify-center"></i>
            搜索漫画
          </button>
        </div>
      )}
    </header>
  );
}